<script setup lang="ts">
withDefaults(defineProps<{ title: string; required?: boolean }>(), { required: false });
</script>
<template>
    <div class="modal-section">
        <div class="section-title">
            {{ title }}<span v-if="required" class="required-asterisk">*</span>
        </div>
        <div class="line"></div>
    </div>
</template>
<style scoped lang="scss">
.modal-section {
    display: flex;
    gap: 12px;
    padding-top: 8px;
    white-space: nowrap;

    .section-title {
        font-weight: 500;
        @include font-size-14;
        margin: 0;

        .required-asterisk {
            color: var(--blue-base, #2051f8);
            margin-left: 2px;
        }
    }
    .line {
        height: 1px;
        width: 100%;
        background-color: $bg-soft-200;
        margin: auto 0;
    }
}
</style>
